/* @ngInject */
const saleData = () => {
  const self = {}

  self.mySales = []

  return self
}
export default saleData



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sale/services/data.service.js